// extracted by mini-css-extract-plugin
var _1 = "ConfirmationModalNotifications-moduleConfirmationModalNotifications__M8jlR";
export { _1 as "ConfirmationModalNotifications" }
